module.exports = __webpack_public_path__ + "405a2c5f036343f54f0e46ab054e7cf8.svg";